module.exports = __webpack_public_path__ + "static/media/DSC_2917.51d97b7e.jpg";